import { Injectable } from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, Router} from "@angular/router";
import { AngularFireAuth } from 'angularfire2/auth';
import { UserService } from '@app/core/services/user.service';


@Injectable()
export class AuthGuard implements CanActivate {

  constructor(
    public afAuth: AngularFireAuth,
    public userService: UserService,
    private router: Router
  ) {}

  canActivate(): Promise<boolean>{
    return new Promise((resolve, reject) => {
      this.userService.getCurrentUser()
      .then(user => {
        // this.router.navigate(['/main']);
        return resolve(false);
      }, err => {
        return resolve(true);
      })
    })
  }

  sendPasswordResetEmail(email){
    return new Promise((resolve,reject) => {
      this.afAuth.auth.sendPasswordResetEmail(email)
      .then( () => {
        return resolve(false);
      }, error => {
        return resolve(true);
      })
    })
  }
}